import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { Season } from './season.model';

import * as moment from 'moment';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
  by_current_seasons?: any;
}

@Injectable({
  providedIn: 'root',
})
export class SeasonService {
  private apiUrl = environment.apiEndpoint + 'seasons';

  constructor(private http: HttpClient, private utilService: UtilService) {}

  getFilterCriteria() {
    const defaultParams: ExtendedDefaultParams = {
      // const defaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getSeasons(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getSeason(id: string, params = null): Observable<Season> {
    const queryParams = new HttpParams({ fromObject: params });

    return this.http.get<Season>(`${this.apiUrl}/${id}`, {
      params: queryParams,
    });
  }

  // Save / Update
  saveSeason(seasonId: string, season: Season, lang = ''): Observable<Season> {
    const body = {
      season: season,
      lang: lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!seasonId) {
      return this.http.post<Season>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<Season>(`${this.apiUrl}/${seasonId}`, body);
    }
  }

  changeSeasonStatus(season, companyId): Observable<Season> {
    let newStatus = season.status === CONSTANTS.ACTIVE ? CONSTANTS.INACTIVE : CONSTANTS.ACTIVE;

    const body = {
      set_status: true,
      check_if_used: true,
      status: newStatus,
      company_id: companyId,
    };

    return this.http.put<Season>(`${this.apiUrl}/${season.id}`, body); // ?set_status=true
  }

  deleteSeason(season, companyId): Observable<Season> {
    /*let params = new HttpParams().set('check_if_used', true);

    const body = {
      params: params,
    };
    , body
    */

    return this.http.delete<Season>(
      `${this.apiUrl}/${season.id}?check_if_used=true&company_id=${companyId}`
    );
  }

  copySeason(seasonId): Observable<Season> {
    const body = {
      season: {},
      option: 'copy_item',
    };

    return this.http.put<Season>(`${this.apiUrl}/${seasonId}`, body);
  }

  setCurrentSeasons(seasons) {
    let today = CONSTANTS.TODAY_DATE;

    let currentSeasons = seasons
      .filter((profileSeason) => profileSeason.season.to >= today)
      .filter(
        (obj, index, self) => self.findIndex((el) => el.season_id === obj.season_id) === index
      );

    currentSeasons = currentSeasons.sort(
      (a, b) => new Date(a.season.from).valueOf() - new Date(b.season.from).valueOf()
      // (a, b) => new Date(a.season.from) - new Date(b.season.from)
    );

    return currentSeasons;
  }

  groupSeasonsByYears(season): string {
    const dateYear = 'YYYY';

    const from = moment(season.from).format(dateYear);
    const to = moment(season.to).format(dateYear);

    return from === to ? from : from + '-' + to;
  }
}
